import { $set, update } from 'qim';

import ActionTypes from 'app/contact-us/ActionTypes';
import { createId } from 'app/common/CommonUtils';
import { createReducer } from 'app/common/utils/ReduxUtils';

const initialState = {
  attemptId: null,
};

const handlers = {
  [ActionTypes.RESET_ATTEMPT_ID](state) {
    return update(['attemptId', $set(createId())], state);
  },
};

const reducer = createReducer(handlers, initialState);

export default reducer;
